import { render, staticRenderFns } from "./TabContenDetail.vue?vue&type=template&id=3fa2b2c0&scoped=true&"
import script from "./TabContenDetail.vue?vue&type=script&lang=js&"
export * from "./TabContenDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2b2c0",
  null
  
)

export default component.exports